import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import { _className, Button } from '@nu-art/thunderstorm-frontend/index';
import { PanelKey_HPI } from '../../../_shared.js';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ICONS } from '@app/styles';
import './AdvisorPanel_HPI.scss';
import { Component_HPI } from '../../components/hpi/Component_HPI/Component_HPI.js';
import { Component_WizardIcon } from '../../components/advisor-wizard/Component_WizardIcon/Component_WizardIcon.js';
export class AdvisorPanel_HPI extends AdvisorPanel {
    static defaultProps = {
        panelKey: PanelKey_HPI,
    };
    //######################### Life Cycle #########################
    __onReadOnlyChanged() {
        this.forceUpdate();
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state); // call super derive to resolve provider type & readonly mode into the state
        return state;
    }
    //######################### Logic #########################
    getPanelClass() {
        return _className(super.getPanelClass(), 'panel__hpi');
    }
    //######################### Render - Header #########################
    refreshHPI = async () => {
        if (ModuleFE_EMInterface.isPostDisposition() || ModuleFE_EMInterface.isReadonly())
            return;
        return ModuleFE_EMInterface.updateEncounterApis.refreshHPI();
    };
    renderHeader_Title = () => 'Chief Complaint & HPI';
    renderHeader_Tail = () => {
        const readonly = ModuleFE_EMInterface.isReadonly();
        return _jsxs(_Fragment, { children: [!readonly && _jsx(Button, { variant: 'header-button', onClick: this.refreshHPI, children: _jsx(ICONS.sync.component, {}) }), _jsx(Component_WizardIcon, { tooltipContent: 'Edit HPI', wizardFilter: w => w.config.isHpi })] });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = undefined;
    //######################### Render - Content #########################
    _renderContent(scrollRef) {
        return _jsx(Component_HPI, { scrollRef: scrollRef });
    }
    renderContent = () => _jsx(_Fragment, {});
    //######################### Render - Footer #########################
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorPanel_HPI.js.map